<div class="flex flex-col h-full w-full">
  <!-- Current values (read-only) -->
  <div class="flex flex-col gap-4 mb-4">
    <prox-field label="Program">
      <input type="text" pInputText [disabled]="true" [value]="program.name" class="w-full" />
    </prox-field>
    <prox-field label="Program Accessibility">
      <input type="text" pInputText [disabled]="true" [value]="program.programStartDateType.name" class="w-full" />
    </prox-field>
    <prox-field label="Current End Date">
      <input type="text" pInputText [disabled]="true" [value]="program.endDate | date : 'MMM d, yyyy'"
        class="w-full" />
    </prox-field>
  </div>

  <!-- New end date -->
  <div class="flex flex-col gap-4 mb-4">
    <prox-field label="New End Date">
      <!-- appendTo="body" so the calendar overlays the dialog. Rendered inline it pushes the
           content down and forces the dialog into a scroll, hiding its own buttons. -->
      <p-datepicker appendTo="body" [(ngModel)]="newEndDate" [minDate]="minDate" [maxDate]="maxDate"
        [readonlyInput]="true" [showIcon]="true" styleClass="w-full"></p-datepicker>
    </prox-field>
    <p class="text-sm text-gray-600">
      Choose a date between {{ minDate | date : 'MMM d, yyyy' }} and {{ maxDate | date : 'MMM d, yyyy' }}. The end
      date must be later than today, and no more than 12 months from today.
    </p>
  </div>

  <!-- Button Bar -->
  <div class="flex pt-2 items-center">
    <p-button (onClick)="onProceed()" label="Proceed" icon="pi pi-check" styleClass="mr-2"></p-button>
    <p-button (onClick)="onCancel()" label="Cancel" icon="pi pi-times" styleClass="mr-2"></p-button>
  </div>
</div>
